export class ProfitBackfillRequestModel {
    public symbols = ''; // Supports single symbol or multiple:  SPY or SPY QQQ AMZN 
}